export default __webpack_public_path__ + "static/media/logo.5f68e35d.png";